import { ProdClient } from 'client/client';
import SinglePersonPage from 'components/pages/ContactUs/SinglePersonPage';
import { Contact as ContactModel, FormModal } from 'models';
import { getContactUsVariants } from 'utils/overviewVariants';

export const getStaticContactProps = async ({ urlParam, locale }: { locale: string; urlParam: string }) => {
  const languageCodename = locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!;

  const [person, form] = await Promise.all([
    ProdClient.items<ContactModel>()
      .type('contact')
      .languageParameter(languageCodename)
      .limitParameter(1)
      .equalsFilter('elements.id', urlParam)
      .collection(process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION!)
      .toPromise()
      .then((res) => res.data.items[0].elements as unknown as Omit<ContactModel['elements'], 'key'>)
      .catch(() => null),
    ProdClient.item<FormModal>('get_in_touch')

      .toPromise()
      .then((res) => res.data.item)
      .catch(() => null),
  ]);

  const variants = await getContactUsVariants('peopleUrl');

  return {
    variants,
    person,
    form,
  };
};

const ContactUsSinglePersonPage = (props: Awaited<ReturnType<typeof getStaticContactProps>>) => {
  return <SinglePersonPage {...props} />;
};

export default ContactUsSinglePersonPage;
